import React from 'react';

const Programs = () => {
  return (
    <div className="container mt-5">
      <h1>Our Coaching Programs</h1>
      <p>
        We offer a variety of coaching programs tailored to different skill levels and learning styles.
      </p>
      <div className="row">
        <div className="col-md-4">
          <div className="card mb-4">
            <div className="card-body">
              <h5 className="card-title">Beginner</h5>
              <p className="card-text">Learn the fundamentals of chess, including rules, basic tactics, and opening principles.</p>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card mb-4">
            <div className="card-body">
              <h5 className="card-title">Intermediate</h5>
              <p className="card-text">Develop your strategic thinking, positional understanding, and endgame skills.</p>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card mb-4">
            <div className="card-body">
              <h5 className="card-title">Advanced</h5>
              <p className="card-text">Master advanced concepts, study grandmaster games, and prepare for tournaments.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Programs;
